<template>
  <div id="app-container">
    <component :is="resolveLayout">
      <router-view></router-view>
    </component>

    <!-- ✅ Bannière WebPush montée si connecté -->
    <NotifPermissionBanner
      v-if="isAuthenticated"
      @activer="initWebPush"
    />

    <!-- ✅ NotificationBadge global (Optionnel, à décommenter si besoin) -->
    <!-- <NotificationBadge v-if="isAuthenticated" /> -->
  </div>
</template>

<script>
import axios from 'axios'
import store from './store'
import { computed, watch } from '@vue/composition-api'
import { useRouter } from '@/utils'
import LayoutBlank from '@/layouts/Blank.vue'
import LayoutContent from '@/layouts/Content.vue'
import NotifPermissionBanner from './components/NotifPermissionBanner.vue'

export default {
  components: {
    LayoutBlank,
    LayoutContent,
    NotifPermissionBanner,
  },
  setup(props, context) {
    const { route } = useRouter()
    store.commit('initialiseStore')

    console.log(store.state.isAuthenticated)

    let token = store.state.token
    if (token) {
      axios.defaults.headers.common['Authorization'] = 'Token ' + token
    } else {
      axios.defaults.headers.common['Authorization'] = ''
    }

    const resolveLayout = computed(() => {
      if (route.value.name === null) return null
      if (route.value.meta.layout === 'blank') return 'layout-blank'
      return 'layout-content'
    })

    const isAuthenticated = computed(() => store.state.isAuthenticated)

    // ── Méthode d'activation manuelle (bannière) ──────────────────
    const initWebPush = async () => {
      if (typeof window._initWebPush === 'function') {
        await window._initWebPush()
      } else {
        console.warn('_initWebPush non disponible sur TopUp')
      }
    }

    // ── Abonnement automatique (si permission déjà granted) ──────
    const autoSubscribeIfNeeded = async () => {
      if (typeof Notification === 'undefined') return
      if (Notification.permission !== 'granted') {
        console.log('ℹ️ Permission non encore accordée – la bannière gérera la demande.')
        return
      }

      const userId = store.getters.userId
      if (!userId || userId === 'anonymous') {
        console.warn('⚠️ ID utilisateur non disponible')
        return
      }

      const flagKey = `webpush_subscribed_${userId}`
      if (localStorage.getItem(flagKey) === 'true') {
        console.log(`✅ WebPush déjà enregistré pour l’utilisateur ${userId}`)
        return
      }

      console.log(`🔄 Abonnement automatique pour l’utilisateur ${userId}`)
      if (typeof window._initWebPush === 'function') {
        try {
          await window._initWebPush()
          localStorage.setItem(flagKey, 'true')
          console.log('✅ Abonnement réussi et flag stocké')
        } catch (e) {
          console.warn('❌ Échec de l’abonnement auto :', e)
        }
      } else {
        console.warn('⚠️ _initWebPush non disponible')
      }
    }

    // ── Watcher sur l'authentification ────────────────────────────
    watch(isAuthenticated, async (newVal) => {
      if (newVal) {
        await context.root.$nextTick()
        autoSubscribeIfNeeded()
      }
    }, { immediate: true })

    return {
      resolveLayout,
      isAuthenticated,
      initWebPush,
    }
  },
}
</script>

<style>
/* style global, NON scoped */
body.chat-open {
  overflow: hidden;
  height: 100%;   /* nécessaire pour empêcher le scroll */
}
body.chat-open footer,
body.chat-open .footer,
body.chat-open .site-footer,
body.chat-open [class*="footer"],
body.chat-open [class*="copyright"] {
  display: none !important;
}
</style>
